import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  ImageBackground,
  ActivityIndicator,
  Platform,
} from 'react-native';
import { ViewPropTypes } from 'deprecated-react-native-prop-types';

class PendingImage extends PureComponent {
  constructor(props, context) {
    super(props, context);

    // this.onLoadStart = this.onLoadStart.bind(this);
    this.onError = this.onError.bind(this);
    this.onLoadEnd = this.onLoadEnd.bind(this);
    this.onLoad = this.onLoad.bind(this);

    const { loadable } = this.props;

    this.state = {
      isLoaded: false, // Start with 'true' until 'onLoadStart' sets it to 'false'
      isError: loadable,
      // isErrorBefore: false,
      reloadCount: 1, // PublisherIcon.getRandomInt(),
    };

    const { source } = this.props;

    console.log('start loading');
    console.log(source);
  }

  componentDidUpdate(prevProps) {
    const { source } = this.props;
    const { source: prevSource } = prevProps;

    const before = JSON.stringify(prevSource);
    const after = JSON.stringify(source);
    if (before !== after) {
      this.setState({
        isLoaded: false,
      });
    }
  }

  // async onLoadStart() {
  //   // const { reloadCount } = this.state;

  //   console.log('onLoadStart');
  //   this.setState({
  //     isLoaded: false,
  //     // reloadCount: reloadCount + 1,
  //   });
  // }

  onLoad({ nativeEvent }) {
    console.log('onLoad');
    console.log(nativeEvent);
    if (!nativeEvent) {
      return;
    }
    const { isTrusted, source } = nativeEvent;
    if (isTrusted) {
      // This is web and there is no width and height
      this.setState({
        isLoaded: true,
      });
      return;
    }
    if (!source) {
      return;
    }
    const { width, height } = source;
    console.log(width);
    console.log(height);
    if (width && height) {
      this.setState({
        isLoaded: true,
      });
    }
  }

  onLoadEnd() {
    const { source } = this.props;
    const { isError, isLoaded, reloadCount } = this.state;

    console.log('onLoadEnd');
    // console.log(this);
    console.log(source);
    console.log(source.uri);

    // FIXME(clairbee): instead of sleeping, use setTimeout() to update the state later

    const stateUpdate = {};
    stateUpdate.isError = false;
    console.log('isError');
    console.log(isError);
    console.log('isLoaded');
    console.log(isLoaded);
    if ((isError || !isLoaded) && Platform.OS !== 'android') {
      stateUpdate.reloadCount = reloadCount + 1;
      console.log('scheduling a retry in that many seconds');
      console.log(reloadCount);
      setTimeout(() => {
        console.log('updating the state of PendingImage to trigger an image reload');
        this.setState(stateUpdate);
      }, reloadCount * 1000);
    } else {
      this.setState(stateUpdate);
    }
  }

  onError() {
    console.log('onError');
    // console.log(this);

    const stateUpdate = {};
    stateUpdate.isError = true;
    stateUpdate.isLoaded = false;

    // On android, onLoadEnd() is not called after onError()
    if (Platform.OS === 'android') {
      const { reloadCount } = this.state;

      stateUpdate.reloadCount = reloadCount + 1;
      setTimeout(() => {
        console.log('updating the state of PendingImage to trigger an image reload');
        this.setState(stateUpdate);
      }, reloadCount * 1000);
    } else {
      this.setState(stateUpdate);
    }
  }

  render() {
    const {
      imageStyle, activityIndicatorStyle, source,
    } = this.props;
    const {
      isLoaded,
      isError,
      reloadCount,
    } = this.state;

    return (
      <ImageBackground
        key={reloadCount}
        // onLoadStart={this.onLoadStart}
        onLoad={this.onLoad}
        onLoadEnd={this.onLoadEnd}
        onError={this.onError}
        style={imageStyle}
        source={source}
        resizeMode="stretch"
      >
        {(!isLoaded || isError) && (
          <ActivityIndicator
            style={activityIndicatorStyle}
            size="small"
            color="blue"
          />
        )}
      </ImageBackground>
    );
  }
}

PendingImage.defaultProps = {
  loadable: false,
  imageStyle: {},
  activityIndicatorStyle: {},
};

PendingImage.propTypes = {
  imageStyle: ViewPropTypes.style,
  activityIndicatorStyle: ViewPropTypes.style,
  loadable: PropTypes.bool,
  source: PropTypes.oneOfType([
    PropTypes.shape({
      uri: PropTypes.string,
      headers: PropTypes.objectOf(PropTypes.string),
    }),
    PropTypes.number,
    PropTypes.arrayOf(
      PropTypes.shape({
        uri: PropTypes.string,
        width: PropTypes.number,
        height: PropTypes.number,
        headers: PropTypes.objectOf(PropTypes.string),
      })
    ),
  ]).isRequired,
};

export default PendingImage;
